import { render } from "./ReportsOrders.vue?vue&type=template&id=5da02725&scoped=true"
import script from "./ReportsOrders.vue?vue&type=script&lang=js"
export * from "./ReportsOrders.vue?vue&type=script&lang=js"

import "./ReportsOrders.vue?vue&type=style&index=0&id=5da02725&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da02725"]])

export default __exports__